import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Switch, Text } from '@reveni-io/reveni-ui'

import LanguageTextInput from '@/configuration/components/LanguageTextInput/LanguageTextInput'

import * as Styles from './styles'

const CustomName = ({
  languages,
  onChangeCustomName,
  customNames,
  onCheckUseCustomName,
  useCustomName,
  disabled,
  errorLanguages = [],
  fieldId,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Text type="titleS">{t('Nombre personalizado')}</Text>
      <Switch
        checked={useCustomName}
        onChange={onCheckUseCustomName}
        label={t('Usar nombre personalizado')}
        disabled={disabled}
      />
      {useCustomName && (
        <Styles.TranslationContainer id={fieldId}>
          <LanguageTextInput
            languages={languages}
            value={customNames}
            onChange={onChangeCustomName}
            backgroundColor={theme.colors.background.primary}
            disabled={disabled}
            validateEmptyOnBlur={false}
            externalErrorLanguages={errorLanguages}
            showInputError
            helperText={t('Este campo es obligatorio')}
          />
        </Styles.TranslationContainer>
      )}
    </Styles.Container>
  )
}

export default CustomName
